// extracted by mini-css-extract-plugin
export default {"values":"Values_values__xuYaJ","values-container":"Values_values-container__sIJoL"};